import { useQuery } from '@tanstack/react-query'
import { queryKeys } from 'commons/hooks/services/queryKeys'
import { successService } from 'commons/services/successService'

const useSuccessCollectInfo = ({
	transactionIdentifier,
	collectSlug
}: {
	transactionIdentifier: string
	collectSlug: string
}) => {
	return useQuery({
		queryKey: queryKeys.successInfo.getSuccessCollectInfo(transactionIdentifier, collectSlug),
		queryFn: () => successService.getSuccessCollectInfo({ transactionIdentifier, collectSlug })
	})
}

export default useSuccessCollectInfo
